import { USER_LOGOUT_CLEAR } from 'constants/ActionTypes';
import * as authTypes from 'modules/auth/actionTypes';
import { LOGIN_STEPS } from 'modules/auth/constant';
import { isImpersonatingUser } from 'modules/auth/utils';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

/**
 * @param {boolean} state
 * @param {import('modules/auth/types').SignInSuccessAction | import('modules/auth/types').LoadSessionSuccessAction} action
 * @returns {boolean}
 */
const handleAuthSuccess = (state, action) => isImpersonatingUser(action.payload);

/**
 * @returns {boolean}
 */
const handleReset = () => false;

/**
 * @param {boolean} state
 * @param {import('modules/auth/types').SetAuthStepAction} action
 * @returns {boolean}
 */
const handleSetAuthStep = (state, { type, payload }) => {
  if (type !== authTypes.SET_AUTH_STEP || payload.step === LOGIN_STEPS.LOGIN) {
    return true;
  }
  return state;
};

export default createReducer(initialState, {
  [authTypes.SIGN_IN_SUCCESS]: handleAuthSuccess,
  [authTypes.LOAD_SESSION_SUCCESS]: handleAuthSuccess,
  [authTypes.SIGN_OUT_REQUEST]: handleReset,
  [USER_LOGOUT_CLEAR]: handleSetAuthStep,
  [authTypes.SIGN_OUT_EMERGENCY]: handleSetAuthStep,
  [authTypes.SET_AUTH_STEP]: handleSetAuthStep,
});
